import styled from 'styled-components';

export const Layout = styled.div.attrs(() => ({
  className: 'layout',
}))`
  display: -ms-flexbox;
  display: flex;
  flex: auto;
  flex-direction: column;
  min-height: calc(100 * var(--full-vh));
  transition: var(--transition-set-3);
`;

export const Wrapper = styled.div.attrs(() => ({
  className: 'wrapper',
}))`
  display: flex;
  flex: auto;
  flex-direction: column;
  min-height: 0;
`;
